// extracted by mini-css-extract-plugin
module.exports = {"loading":"cL","fullscreenWrapper":"cM","centeredSpinner":"cN","rotation":"cO","withoutLayer":"cP"};